import React from 'react'
import { useNavigate } from 'react-router-dom'

export default function DrillDownCell({ value, drillDownType, row = {} }) {
  const navigate = useNavigate()

  if (!value) return <span className="text-slate-400">—</span>

  // Resolve target entity ID from row
  let targetId = null
  let routePath = null

  if (drillDownType === 'project') {
    targetId = row.project_id || row.id
    if (targetId) routePath = `/project-management/project/detail?id=${targetId}`
  } else if (drillDownType === 'task') {
    targetId = row.task_id || row.id
    if (targetId) routePath = `/project-management/task/entry?id=${targetId}`
  } else if (drillDownType === 'job') {
    targetId = row.job_id || row.id
    if (targetId) routePath = `/project-management/job/entry?id=${targetId}`
  } else if (drillDownType === 'ticket') {
    targetId = row.ticket_id || row.id
    if (targetId) routePath = `/support/tickets/entry?id=${targetId}`
  } else if (drillDownType === 'user') {
    targetId = row.user_id || row.id
    if (targetId) routePath = `/masters/users/entry/${targetId}`
  }

  if (routePath) {
    return (
      <button
        type="button"
        onClick={(e) => {
          e.stopPropagation()
          navigate(routePath)
        }}
        className="text-primary font-semibold hover:underline flex items-center gap-1 group text-left"
        title={`Open ${drillDownType} details in module`}
      >
        <span>{String(value)}</span>
        <span className="material-symbols-outlined text-xs opacity-0 group-hover:opacity-100 transition-opacity">
          open_in_new
        </span>
      </button>
    )
  }

  return <span>{String(value)}</span>
}
